import React from 'react';
import {firebaseConnect} from "react-redux-firebase";
import {compose} from "redux";
import {connect} from "react-redux";
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import CaAccountModalView from "./CaAccountModalView";
import {VIEW_CHANGE_EMAIL, VIEW_DELETE_ACCOUNT} from "../../constants/accountModalConstants";
import * as actions from "../../actions/accountModalActions";

const CaAccountUpdateProfileContainer = props => {

    const { onNavigate, profile } = props;

    if  (!profile) {
        return <div />
    }

    const countryList = i18n.store.data.en.translations.country_list;
    const newProps = Object.assign({},{
        formFieldsData: [
            {type:'text',validateAs:'text',placeholder:props.t('account_modal.placeholders.name'),id:"update_name", value:profile.name},
            {type:'text',validateAs:'text',placeholder:props.t('account_modal.placeholders.lastname'),id:"update_lastname", value:profile.lastname},
        ],
        selectData: {type:'select',validateAs:'select', id:"update_country",data:countryList, value:profile.country},
        actions: [
            {
                label:props.t('account_modal.change_email_cta'),
                onClick: ()=>onNavigate(VIEW_CHANGE_EMAIL)
            },
            {
                label:props.t('account_modal.delete_account_cta'),
                onClick: ()=>onNavigate(VIEW_DELETE_ACCOUNT)
            },
        ],
        "title": props.t('account_modal.update_profile.title'),
        "submitCta": props.t('account_modal.update_profile.submitCta'),
        "success_message": props.t('account_modal.update_profile.success_message')   
    });
    return (
        <CaAccountModalView
            {...Object.assign({},props,newProps)}
        />
    )
};
export default compose(
    connect((state) => ({ profile:state.firebase.profile }),actions),
    firebaseConnect()

)(withTranslation("translations")(CaAccountUpdateProfileContainer))